import { useState } from 'react';
import { useGuest } from '@/contexts/GuestContext';
import { useLocation } from 'react-router-dom';

export const useGuestGuard = () => {
  const { isGuest, promptSignUp } = useGuest();
  const location = useLocation();
  const [showBlocker, setShowBlocker] = useState(false);
  const [blockerMessage, setBlockerMessage] = useState('');
  const [intendedAction, setIntendedAction] = useState<{ route: string; action?: string } | undefined>();

  const checkGuestAction = (customMessage?: string, actionName?: string): boolean => {
    if (isGuest) {
      const message = customMessage || 'Sign in or sign up to use this feature';
      setBlockerMessage(message);
      setIntendedAction({ route: location.pathname, action: actionName });
      setShowBlocker(true);
      return false;
    }
    return true;
  };

  const closeBlocker = () => {
    setShowBlocker(false);
    setIntendedAction(undefined);
  };

  return {
    isGuest,
    checkGuestAction,
    showBlocker,
    closeBlocker,
    blockerMessage,
    intendedAction
  };
};
